import React from 'react';

import { withTheme } from 'emotion-theming';
import { lighten } from 'polished';

import {
  BREAKPOINTS,
  INNER_GUTTER,
  OUTER_GUTTER,
  getColWidthCalc,
  unit,
} from '@zego/theme';

import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';
import StaticImage from '@zego/components/StaticImage';

import Mitochondria from '@zego/static/svgs/Mitochondria.svg';

const LeftFeature = ({
  image,
  children,
  theme: { tintColor },
  variant = 'A',
}) => (
  <SectionDisplay>
    <ContentContainer>
      <div
        css={{
          [BREAKPOINTS.medium]: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          },
        }}
      >
        <div
          css={{
            paddingBottom: unit(12),
            [BREAKPOINTS.medium]: {
              paddingBottom: 0,
              width: getColWidthCalc(12, 20, 4),
              marginRight: `calc(${INNER_GUTTER}px + ${getColWidthCalc(
                12,
                20,
                2,
              )})`,
            },
          }}
        >
          {children}
        </div>
        <div
          css={{
            '::before': {
              zIndex: -1,
              content: '""',
              position: 'absolute',
              background: `url(${Mitochondria}) no-repeat, linear-gradient(to left, ${lighten(
                0.1,
                tintColor,
              )}, ${tintColor})`,
              backgroundSize: `100% 100%, calc(100% - 2px) calc(100% - 2px)`,
              backgroundPosition: `0 0, 1px 1px`,
              backgroundRepeat: `no-repeat, no-repeat`,
              WebkitBackfaceVisibility: 'hidden',

              ...(image
                ? {
                    width: '100vw',
                    height: '67vw',
                    top: 0,
                    left: 0,
                    right: 'auto',
                    transform: 'scaleX(1.2) scaleY(-1.3) rotate(3deg)',
                  }
                : {
                    width: 500,
                    height: 335,
                    top: -138,
                    left: 'auto',
                    right: -26,
                    transform: `scaleX(0.8) scaleY(-0.8) rotate(3deg)`,
                  }),

              [BREAKPOINTS.medium]: {
                width: 970,
                height: 650,
                marginTop: -650 / 2,
                top: '50%',
                right: 0,
                left: 'auto',
                transform: {
                  A: `scaleX(1) scaleY(-1) translateX(500px) translateY(-90px) rotate(3deg)`,
                  B: `scaleX(1) scaleY(1) translateX(500px) translateY(20px) rotate(0deg)`,
                }[variant],
              },
            },
            position: 'relative',
            [BREAKPOINTS.medium]: {
              width: `calc(${INNER_GUTTER}px + ${getColWidthCalc(12, 20, 6)})`,
            },
          }}
        >
          {image ? (
            <StaticImage
              alt=""
              src={image}
              ratio={1.5}
              css={{
                display: 'block',
                width: `calc(100% + ${OUTER_GUTTER}px)`,
                left: -OUTER_GUTTER,
                position: 'relative',
                borderRadius: '0 4px 4px 0',
                [BREAKPOINTS.medium]: {
                  borderRadius: 4,
                  top: 0,
                  left: 0,
                  boxShadow: '0 10px 100px 0 rgba(0, 0, 0, .25)',
                },
              }}
            />
          ) : null}
        </div>
      </div>
    </ContentContainer>
  </SectionDisplay>
);

export default withTheme(LeftFeature);
